define(['./../_SegmentationUtil'], (_SegmentationUtil)=> {
    return [()=> {

        return {
            restrict: 'EA',
            scope: {
                params: '=?', // {Object} optional parmeters that can be passed to experiment service
                experiment: '@' // if the value is provided the option is triggered to be shown
            },
            controller: ['$element', '$scope', 'gwAbExperimentService', function ($element, $scope, AbExperimentService) {
                const experimentResult = AbExperimentService.getExperimentValue($scope.experiment, $scope.params);
                return _SegmentationUtil($element, experimentResult);
            }]
        };
    }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/segmentation/abexperiment/AbExperimentSegmentationDirective.js